import React from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import queryString from 'query-string';

import ProgressBackdrop from '@/components/ProgressBackdrop';

import { useAuthDispatch } from '@/plugins/Auth';

import { KEY_LOGIN_STATE } from './OAuthLogin';
import { getRedirectURI } from '../../../services/line';

const OAuthCallback = () => {
  const history = useHistory();
  const { search } = useLocation();
  const { provider } = useParams();
  const authDispatch = useAuthDispatch();

  React.useEffect(() => {
    const {
      code,
      state,
    } = queryString.parse(search);

    if (!code) return;

    let afterLoginUrl = null;
    let restOfState = null;
    try {
      // NOTE: Restore state data from storage.
      const stateFromStorage = JSON.parse(localStorage.getItem(KEY_LOGIN_STATE) || '{}');
      localStorage.removeItem(KEY_LOGIN_STATE);
      const {
        loginId,
        afterLoginUrl: afterLoginUrlFromStorage,
        ...restOfStateFromStorage
      } = stateFromStorage;
      if (`${loginId}` === `${state}`) {
        afterLoginUrl = afterLoginUrlFromStorage;
        restOfState = restOfStateFromStorage;
      }
    } catch (error) {
      // This operation is optional, we could just ignore this error.
    }

    switch (provider) {
      case 'line':
        if (restOfState?.action === 'connectThirdPartyAccount') {
          history.push('/register/connect-third-party-account', {
            afterLoginUrl,
            code,
            thirdPartyName: 'line',
            redirectUri: getRedirectURI(),
            ...restOfState,
          });
        } else {
          history.push('/login/line/callback', {
            afterLoginUrl,
            code,
            redirectUri: getRedirectURI(),
            ...restOfState,
          });
        }
        break;
      default:
        break;
    }
  }, [history, search, authDispatch, provider]);

  return <ProgressBackdrop isShow />;
};

export default OAuthCallback;
